import React, { PropsWithChildren } from 'react';
import { vibrate } from '../../Utils/Helpers';
import ButtonBase from './ButtonBase';

interface ButtonPrimaryProps {
  onClick: CallableFunction;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const ButtonPrimary = ({
  children,
  onClick = () => {},
  disabled,
  className,
  outline = false,
  type = 'button',

}: PropsWithChildren<ButtonPrimaryProps>) => {

  const handleClick = () => {
    onClick();
    vibrate();
  }

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`
        ${className} text-custom-primary ring-custom-primary hover:ring-custom-primary-hover ring-2
        ${outline ? 'text-custom-primary text-custom-primary hover:text-custom-primary-hover hover:bg-gray-50' : 'text-white bg-custom-primary hover:bg-custom-primary-hover'}
    `}>
      {children}
    </ButtonBase>
  )
}

export default ButtonPrimary;